import ACTIONS from '@/store/storeActions';

const mutations = {
  [ACTIONS.ADD_NOTE]: (state, payload) => {
    if (!state.notes) state.ntoes = [];
    if (Array.isArray(payload)) {
      for (const note of payload) {
        state.notes.push(note);
      }
    } else {
      state.notes.push(payload);
    }
  },
  [ACTIONS.REMOVE_NOTE]: (state, payload) => {
    const toRemove = state.notes.filter( (note) => !note.id || note.id === payload.id)
    for (const removeItem of toRemove) {
      const index = state.notes.indexOf(removeItem);
      if (index > -1) {
        state.notes.splice(index, 1);
      }
    }
  },
  [ACTIONS.UPDATE_NOTE]: (state, payload) => {
    const findAndApply = (note) => {
      const toModify = state.notes.find( (x) => x.id && x.id === note.id )
      if (toModify) {
        for (const key of Object.keys(note)) {
          toModify[key] = note[key];
        }
        console.log('UPDATED NOTE IN STORE', toModify);
      }
    }

    if (Array.isArray(payload)) {
      for (const note of payload) {
        findAndApply(note);
      }
    } else {
      findAndApply(payload);
    }
  },
}

export default mutations
